import { Building2, Layers, Users as UsersIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

import { type TeamTypeEnum } from 'src/api/main'

import type { OrgNodeKind } from '../types'

/** API value → display kind. */
export const apiTypeToKind = (
  type: TeamTypeEnum | null | undefined
): OrgNodeKind => {
  switch (type) {
    case 'branch':
      return 'division'
    case 'department':
      return 'department'
    case 'section':
      return 'team'
    default:
      return 'team'
  }
}

/** Display kind → API value. */
export const kindToApiType = (kind: OrgNodeKind): TeamTypeEnum => {
  switch (kind) {
    case 'division':
      return 'branch'
    case 'department':
      return 'department'
    case 'team':
      return 'section'
  }
}

export const KIND_COLOR: Record<OrgNodeKind, string> = {
  division: '#2563EB',
  department: '#7C3AED',
  team: '#0F766E'
}

export const KIND_ICON: Record<OrgNodeKind, LucideIcon> = {
  division: Building2,
  department: Layers,
  team: UsersIcon
}

/**
 * Append an 8-bit alpha to a 6-digit hex color to produce a soft tint
 * (e.g. `tintHex('#2563EB')` → `'#2563EB1F'`, ~12% opacity).
 * Used everywhere we render a kind-colored chip behind an icon or tag.
 */
export const tintHex = (hex: string, alpha = '1F'): string => `${hex}${alpha}`

/** Child kind for a given parent kind, used when adding sub-units. */
export const childKindOf = (parent: OrgNodeKind): OrgNodeKind | null => {
  if (parent === 'division') return 'department'
  if (parent === 'department') return 'team'
  return null
}
